import './array.forEach';
import './array.findIndex';
import './array.find';
import './custom-event';
import './matches';
import './scroll-y';
import './element.remove';
import './nodeList.forEach';
import './array.from';
import './string.startsWith';
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
// This is not a library that makes the scrolling smooth - 
// instead it polyfills window.scrollTo({behavior: 'smooth'})
import smoothscroll from 'smoothscroll-polyfill';
// kick off the polyfill!
smoothscroll.polyfill();
